var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"align-center hint footer"},[_c('router-link',{attrs:{"to":"/changelog"}},[_vm._v("\n        Version "+_vm._s(_vm.version)+".\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }